import React, { useState, useEffect, useLayoutEffect, useRef, Fragment } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Card, CardBody, Input, Button, Table, FormGroup, Label, UncontrolledDropdown, DropdownToggle, DropdownMenu, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import moment from "moment";
import { toast } from 'react-toastify';
import { cloneDeep, filter, isEmpty, isNil, startsWith } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import { connect } from 'react-redux';
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import NavTab from '../../components/NavTab';
import { baseUrl } from '../../constants/environment';
import styled from 'styled-components';
import TextUtils from '../../helpers/TextUtils';
import ToggleButton from '../../common/ToggleButton';
import IconCalendarBlack from '../../assets/images/icon/ic_calendar-black.svg';
import NavTabNutri from '../../components/NavTabNutri';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import queryString from 'query-string';
import PriceUtils from '../../helpers/PriceUtils';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import IconSearch from '../../assets/images/icon-search.png';
import IconPlus from "../../assets/images/icon-plus.png";
import IconSetting from '../../assets/images/icon-setting.png';
import AddSheet from './components/AddSheet';
import MonthSelect from "flatpickr/dist/plugins/monthSelect/index";
import WeekSelect from "flatpickr/dist/plugins/weekSelect/weekSelect";
import { checkRole } from '../../helpers/Roles';

interface Props {
    history: any,
    location: any,
    match: any,
    user: any,
}


const TABS:any = [
    {
        value:'sheet',
        label: "Lịch làm việc"
    },
    {
        value:'shift',
        label: "Cấu hình ca làm việc"
    },
]

const initialParams = {
    page: 1,
    limit: 25,
    filter: {
        tab: 'sheet',
        action: 'view',
        day: moment().format('YYYY-MM-DD'),
        from: moment().startOf('isoWeek').format('YYYY-MM-DD'),
        to: moment().endOf('isoWeek').format('YYYY-MM-DD'),
    }
}

const Shift: React.FC<Props> = (props: any) => {
    const {from, user} = props
    const [{ page, limit, filter }, setParams] = useState<any>(initialParams);
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState<any>();
    const searchPrams = queryString.parse(props.location.search)
    const setPage = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            page: value
        }));
    }

    const setLimit = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            limit: value
        }));
    }

    const setFilter = (value: {}) => {
        setParams((prevState: any) => ({
            ...prevState,
            filter: value
        }));
    }

    const getFilterParams = () => {
        const newFilter: any = {}
        if (!isEmpty(searchPrams)) {
            Object.keys(searchPrams).map(function (key) {
                switch (key) {
                    case 'page':
                        setPage(Number(searchPrams[key]))
                        break;
                    case 'limit':
                        setLimit(Number(searchPrams[key]))
                        break;
                    default:
                        newFilter[key] = searchPrams[key]
                        break;
                }
            });
            setFilter(newFilter)
        }
    }

    const setFilterParams = (params: any) => {
        var filterParams = ''
        Object.keys(params).map(function (item, i) {
            if (i === 0) {
                if (params[item]) filterParams = filterParams + '?' + item + '=' + params[item]
            } else {
                if (params[item]) filterParams = filterParams + '&' + item + '=' + params[item]

            }
        });
        props.history.push({
            search: filterParams
        })
    }

    useEffect(() => {
        getFilterParams()
        document.title = 'Phân lịch phòng khám'
    }, []);

    useEffect(() => {
        setFilterParams({
            page:page,
            limit: limit,
            ...filter,
            day: moment(filter?.day).format('YYYY-MM-DD'),
            from: filter?.from ? moment(filter?.from).startOf('isoWeek').format('YYYY-MM-DD') : moment().startOf('isoWeek').format('YYYY-MM-DD'),
            to: filter?.to ? moment(filter?.to).endOf('isoWeek').format('YYYY-MM-DD') : moment().endOf('isoWeek').format('YYYY-MM-DD'),
        });
    }, [filter, page, limit]);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    return (
        <div style={{paddingBottom:50}}>
            <React.Fragment>
                <PageTitle
                    breadCrumbItems={[
                        { label: `Phân lịch phòng khám`, active: true },
                    ]}
                    title={`Phân lịch phòng khám`}
                />
                <div className="mb-3">
                    <NavTabNutri
                        {...props}
                        tabList={TABS}
                        setTab={(tab: string) => setFilter({
                            ...filter,
                            action: 'view',
                            tab: tab
                        })}
                        tab={filter?.tab || 'sheet'}
                        
                    />
                </div>
                {filter?.tab === 'sheet' &&
                <ContentSheetPage 
                    {...props}
                    filter={filter}
                    setFilter={setFilter}
                    action={action}
                    handleActionModal={(data:any) => handleActionModal(data)}
                />}
                {filter?.tab === 'shift' &&
                <ContentShiftPage 
                    {...props}
                    filter={filter}
                    setFilter={setFilter}
                    action={action}
                    handleActionModal={(data:any) => handleActionModal(data)}
                />}
                <ModalPopup
                    isOpen={modalIsOpen}
                    onRequestClose={() => setIsOpen(false)}
                >
                    {
                        action?.type === 'addSheet' ? <AddSheet closeModal={() => setIsOpen(false)} onRefresh={()=>{
                            setFilter({...filter})
                        }} action={action}/>
                        :<RenderActionModal closeModal={() => setIsOpen(false)} action={action} />
                    }
                </ModalPopup>
                {loading && <Loader />}
            </React.Fragment>
        </div>
    );
};

export const getDaysBetweenDates = (startDate:any,endDate:any,format = 'DD/MM/YYYY') =>{
    const dates = [];
    const currDate = moment(startDate).startOf('day');
    const lastDate = moment(endDate).startOf('day');
    dates.push(currDate.clone().format(format));
    while (currDate.add(1, 'days').diff(lastDate) <= 0) {
        dates.push(currDate.clone().format(format));
    }
    return dates;
};

const ContentSheetPage = (props:any) => {
    const {type, user, onlyView, action, handleActionModal, from, filter, setFilter} = props
    const [data, setData] = useState<any>({})
    const [dataSheet, setDataSheet] = useState<any>([])
    const [clinic, setClinic] = useState<any>([]);
    const [shift, setShift] = useState<any>([]);
    const [doctor, setDoctor] = useState<any>([]);
    const [loading, setLoading] = useState(false)
    const dates:any = getDaysBetweenDates(moment(filter.from, 'YYYY-MM-DD'), moment(filter.to, 'YYYY-MM-DD'))

    let clinics = clinic
    let shifts = shift
    if(filter?.clinic_id) clinics = clinics?.filter((item:any)=>{
        return item?.id == filter?.clinic_id 
    })
    if(filter?.shift_id) shifts = shifts?.filter((item:any)=>{
        return item?.id == filter?.shift_id 
    })

    const sheetLockUp:any = {}
    dataSheet?.map((item:any)=>{
        if(!sheetLockUp[item?.shift_line_id?.id]) sheetLockUp[item?.shift_line_id?.id] = {}
        if(!sheetLockUp[item?.shift_line_id?.id][item?.clinic_id?.id]) sheetLockUp[item?.shift_line_id?.id][item?.clinic_id?.id] = {}
        if(!sheetLockUp[item?.shift_line_id?.id][item?.clinic_id?.id][moment(item?.day).startOf('day').valueOf()]) sheetLockUp[item?.shift_line_id?.id][item?.clinic_id?.id][moment(item?.day).startOf('day').valueOf()] = {}
        sheetLockUp[item?.shift_line_id?.id][item?.clinic_id?.id][moment(item?.day).startOf('day').valueOf()] = item
    })
    
    useEffect(() => {
        loadInit()
    }, []);

    useEffect(() => {
        loadData()
    }, [filter]);

    const loadInit = async () => {
        const params = {
            status:1,
            page:1,
            limit: 100,
        }
        const [
            responseClinic,
            responseUsertitleDoctor
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/clinic`, {
                ...params,
            }),
            APIClient.GET(`${baseUrl}/usertitle/config`,{
                type: 'doctor'
            })
        ]);
        if (responseClinic.response?.data !== undefined) {
            let ListArr:any = [];
            responseClinic.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setClinic([...ListArr])
        }
        if (responseUsertitleDoctor.response !== undefined) {
            const usertitle_ids = responseUsertitleDoctor?.response?.usertitle_ids ? JSON.parse(responseUsertitleDoctor?.response?.usertitle_ids) : []
            fetchUserDoctor(usertitle_ids)
        }
    }

    const fetchUserDoctor = async (usertitle_ids:number[]) => {
        const url = `${baseUrl}/user`;
        const params={
            limit:500,
            status: 1,
            usertitle_ids : usertitle_ids || undefined
        }
        setLoading(true)
        let response: any = await APIClient.GET(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            let Arr:any = [{
                value: "",
                label: "-Để trống-",
            }];
            response.response?.data?.map((e:any) => {
                Arr?.push({
                    value: e?.id,
                    label: e?.name,
                    ...e,
                })
            })
            setDoctor([...Arr])
        }
    }

    const loadData = async () => {
        const formData = {
            ...filter,
            branch_id: user?.branch_id?.id,
        }
        if(formData?.from && formData?.to) {
            formData.from = moment(formData?.from).startOf('day').valueOf()
            formData.to = moment(formData?.to).startOf('day').valueOf()
        }
        console.log("formData", formData)
        const url = `${baseUrl}/shift`;
        setLoading(true)
        let response: any = await APIClient.GET(url, formData);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response?.response?.data;
            const resDataSheet = response?.response?.sheet;
            const dataShift = resData && resData[0] || {}
            setData({...resData && resData[0] || {}})
            setDataSheet([...resDataSheet] || [])
            setShift([...dataShift?.detail?.reduce((prev:any, item:any)=>{
                prev = [...prev,{
                    ...item,
                    value: item?.id,
                    label: item?.name,
                }]
                return prev
            },[]) || []])
        } 
    }

    const handleChangeDoctor = async (sheet:any, userCurent:any) => {
        //check ca trong ngày
        const sheetCurents = dataSheet?.filter((item:any)=>{
            return moment(item?.day).valueOf() === moment(sheet?.day).valueOf() && item?.shift_line_id?.id === sheet?.shift_line_id && item?.user_id?.id === sheet?.user_id
        })
        const sheetCurent = sheetCurents && sheetCurents[0] || {}
        // console.log("handleChangeDoctor", userCurent?.user_id?.id, sheetCurent.user_id?.id, sheet?.user_id)
        if(userCurent?.user_id?.id && sheetCurent.user_id?.id && userCurent?.user_id?.id === sheetCurent.user_id?.id){
            //chọn chính nó
            return 
        }else if(!userCurent?.user_id?.id && !sheetCurent.user_id?.id){
            //Nếu bác sĩ chưa được phân vào phòng nào trong ca và ngày đó 
            //--> Auto Cập nhật Tên bác sĩ vào Phòng tương ứng trong Danh sách phân lịch phòng khám
            handleSaveDoctor(sheet)
        }else if(!userCurent?.user_id?.id && sheetCurent.user_id?.id){
            // Nếu bác sĩ đã được phân vào 1 phòng trong ca và ngày đó --> Hiển thị pop-up xác nhận: "Bác sĩ được chọn sẽ chuyển tới phòng làm việc mới này và phòng làm việc cũ sẽ chuyển thành phòng trống."
            // --> Cập nhật Tên bác sĩ vào Phòng tương ứng trong Danh sách phân lịch phòng khám + Làm rỗng phòng cũ trong ca và ngày đó
            return handleActionModal({
                type: 'changeDoctorConfirm',
                title: 'Bác sĩ được chọn sẽ chuyển tới phòng làm việc mới này và phòng làm việc cũ sẽ chuyển thành phòng trống.',
                onSubmit: () => {
                    handleSaveDoctor(sheet)
                }
            })
        }else if(userCurent?.user_id?.id && !sheetCurent.user_id?.id && !sheet?.user_id){
            return handleActionModal({
                type: 'changeDoctorConfirm',
                title: 'Phòng này sẽ để trống và bác sĩ cũ sẽ chuyển trạng thái chưa được sắp xếp vào phòng nào.',
                onSubmit: () => {
                    handleSaveDoctor(sheet)
                }
            })
        }else if(userCurent?.user_id?.id && !sheetCurent.user_id?.id){
            
            
            // Chọn bác sĩ chưa được phân phòng trong ca và ngày đó --> Hiện pop-up xác nhận: "Bác sĩ được chọn sẽ chuyển tới phòng làm việc này và bác sĩ cũ sẽ chuyển trạng thái chưa được sắp xếp vào phòng nào." 
            // --> Cập nhật Tên bác sĩ vào Phòng tương ứng trong Danh sách phân lịch phòng khám + Chuyển trạng thái chưa xếp phòng cho bác sĩ cũ trong ca và ngày đó
            return handleActionModal({
                type: 'changeDoctorConfirm',
                title: 'Bác sĩ được chọn sẽ chuyển tới phòng làm việc này và bác sĩ cũ sẽ chuyển trạng thái chưa được sắp xếp vào phòng nào.',
                onSubmit: () => {
                    handleSaveDoctor(sheet)
                }
            })
        }else if(userCurent?.user_id?.id && sheetCurent.user_id?.id && userCurent?.user_id?.id !== sheetCurent.user_id?.id){
            // Chọn bác sĩ đã được phân phòng trong ca và ngày đó --> Hiện pop-up xác nhận: "Bác sĩ được chọn sẽ chuyển tới phòng làm việc này và bác sĩ cũ sẽ chuyển phòng làm việc cho bác sĩ được chọn."
            // --> Tráo đổi bác sĩ ở hai phòng và cập nhật Tên bác sĩ vào Phòng tương ứng trong Danh sách phân lịch phòng khám
            return handleActionModal({
                type: 'changeDoctorConfirm',
                title: 'Bác sĩ được chọn sẽ chuyển tới phòng làm việc này và bác sĩ cũ sẽ chuyển phòng làm việc cho bác sĩ được chọn.',
                onSubmit: () => {
                    handleSaveDoctor(sheet)
                }
            })
        }else{
            handleSaveDoctor(sheet)
        }
    }

    const handleSaveDoctor = async (sheet:any) => {
        const url = `${baseUrl}/shift/sheet`;
        let response: any = await APIClient.POST(url, sheet);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            loadData()
            setFilter({
                ...filter,
                action: 'view',
                tab: 'sheet'
            })
        }
    }

    const DataFilter = (props: any) => {
        const { doctor, care, setFilter, filter, clinic, nurse, reception, dataCount, columnService} = props
        const [name, setName] = useState(filter?.name);
        const timer = useRef<any>(null);

        useEffect(() => {
            if (name === filter?.name || (isEmpty(name) && isEmpty(filter?.name))) return
            timer.current = setTimeout(() => {
                setFilter({
                    ...filter,
                    name: name
                })
            }, 1500);
    
            return () => clearTimeout(timer.current);
        }, [name]);
    
        const handleKeyDown = (e: any) => {
            if (e.key === 'Enter') {
                clearTimeout(timer.current)
                setFilter({
                    ...filter,
                    page: 1,
                    name: e.target.value,
                })
            }
        }
    
        const handleChange = (e: any) => {
            clearTimeout(timer.current)
            const { name, value } = e?.target
            setFilter({
                ...filter,
                page: 1,
                [name]: value
            })
        }
    
        const handleChangeFilterDate = (date:any) => {
            if(date.length === 2){
                const from = moment(date[0]).startOf("day").format('YYYY-MM-DD')
                const to = moment(date[1]).endOf("day").format('YYYY-MM-DD')
                setFilter({
                    ...filter,
                    from:from,
                    to:to
                })
            }else if(date.length === 0){
                setFilter({
                    ...filter,
                    from: initialParams?.filter?.from,
                    to: initialParams?.filter?.to
                })
            }   
        }
        
        return (
            <Row className="mb-1 filter-custom">
                <Col xl={9}>
                    <Row>
                        <Col xl={4}>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend" className='input-group-prepend-input'>
                                    <img src={IconSearch} width={18} height={18} alt=""/>
                                </InputGroupAddon>
                                <Input className='mb-2' onKeyDown={handleKeyDown} onChange={(e: any) => setName(e.target.value)} type="text" value={name} placeholder="Tên bác sĩ" />
                            </InputGroup>
                        </Col>
                        <Col xl={2}>
                            <Select
                                className="react-select mb-2"
                                classNamePrefix="react-select"
                                placeholder="-Phòng khám-"
                                options={[{
                                    value: "",
                                    label: "-Phòng khám-",
                                }, ...clinic]}
                                onChange={(value: any) => {
                                    handleChange({ target: { name: 'clinic_id', value: value.value } })
                                }}
                                value={[{
                                    value: "",
                                    label: "-Phòng khám-",
                                }, ...clinic]?.filter((option: any) => filter?.clinic_id === option.value)}
                            ></Select>
                        </Col>
                        <Col xl={2}>
                            <Select
                                className="react-select mb-2"
                                classNamePrefix="react-select"
                                placeholder="-Ca-"
                                options={[{
                                    value: "",
                                    label: "-Ca-",
                                }, ...shift]}
                                onChange={(value: any) => {
                                    handleChange({ target: { name: 'shift_id', value: value.value } })
                                }}
                                value={[{
                                    value: "",
                                    label: "-Ca-",
                                }, ...shift]?.filter((option: any) => filter?.shift_id === option.value)}
                            ></Select>
                        </Col>
                        <Col xl={4}>
                            <InputGroup className='form-control picker-custom'>
                                <Flatpickr 
                                    value={[new Date(moment(filter?.from,'YYYY-MM-DD').startOf('day').valueOf()), new Date(moment(filter?.to,'YYYY-MM-DD').endOf('day').valueOf())]}
                                    // onChange={(date:any) => { handleChangeFilterDate(date) }} 
                                    onChange={(date:any) => { 
                                        const day = moment(date[0]).endOf("day").format('YYYY-MM-DD')
                                        const from = moment(day).startOf('isoWeek')
                                        const to = moment(day).endOf('isoWeek')
                                        setFilter({
                                            ...filter,
                                            day:day,
                                            from:from,
                                            to:to,
                                        })
                                    }} 
                                    options={{
                                        mode: "range",
                                        locale: Vietnamese,
                                        dateFormat: "d/m/Y",
                                        plugins: [new WeekSelect({})],
                                    }}
                                    className="flatpickr-input active"
                                    placeholder="Ngày ca"
                                />
                                <div className="icon-clear" style={{right:23}} onClick={()=>{setFilter({...filter, from: initialParams?.filter?.from, to: initialParams?.filter?.to})}}>
                                    <i className="uil-times mr-1"></i>
                                </div>
                                <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                        <img src={IconCalendarBlack} alt="icon" />
                                </InputGroupAddon>
                            </InputGroup>
                        </Col>
                        {/* <Col xl={4}>
                            <InputGroup className='form-control picker-custom'>
                                <Flatpickr 
                                    value={[new Date(moment(filter?.day,'YYYY-MM-DD').startOf('day').valueOf())]}
                                    onChange={(date:any) => { 
                                        const day = moment(date[0]).endOf("day").format('YYYY-MM-DD')
                                        const from = moment(day).startOf('isoWeek')
                                        const to = moment(day).endOf('isoWeek')
                                        setFilter({
                                            ...filter,
                                            day:day,
                                            from:from,
                                            to:to,
                                        })
                                    }} 
                                    options={{
                                        locale: Vietnamese,
                                        dateFormat: "d/m/Y",
                                    }}
                                    className="flatpickr-input active"
                                    placeholder="Ngày ca"
                                />
                                <div className="icon-clear" style={{right:23}} onClick={()=>{setFilter({...filter, from: null, to:null})}}>
                                    <i className="uil-times mr-1"></i>
                                </div>
                                <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                        <img src={IconCalendarBlack} alt="icon" />
                                </InputGroupAddon>
                            </InputGroup>
                        </Col> */}
                    </Row>
                </Col>
                {checkRole(props?.user?.roles, ['addSheet', 'editSheet'], props?.user?.role) &&
                <Col xl={3}>
                    <div className="text-right" style={{
                        display: 'flex',
                        justifyContent: 'flex-end'
                    }}>
                        <Button color="success" className="ml-2" onClick={()=>{
                            props?.handleActionModal({
                                type:'addSheet',
                                data: {
                                    day_from: moment().add(1, 'week').startOf("isoWeek").format('YYYY-MM-DD'),
                                    day_to: moment().add(1, 'week').endOf("isoWeek").format('YYYY-MM-DD'),
                                }
                            })
                        }}>
                            Cấu hình nhanh
                        </Button>
                    </div>
                </Col>}
                
            </Row>
        );
    };

    const RenderStatus = () => {
        return (
            <div className='calendar-status-item mb-3'>
                <div className='item'>
                    <span className='status-disabled'></span> Không hoạt động
                </div>
                <div className='item'>
                    <span className='status-active'></span> Đang làm việc
                </div>
                <div className='item'>
                    <span className='status-pending'></span> Đang tạm nghỉ
                </div>
            </div>
        )
    }

    const RenderHeadData = () => {
        
        return (
            <thead>
                <tr>
                    <th rowSpan={2} className='p-3' style={{maxWidth: '100px', width: '7%'}} >Ca</th>
                    <th rowSpan={2} className='p-3' style={{maxWidth: '100px', width: '7%'}} >Phòng</th>
                    {dates&&dates?.map((dateItem:any,index:number)=>{
                        const dayName = moment(dateItem, 'DD/MM/YYYY').format('dddd');
                        const active = moment(dateItem, 'DD/MM/YYYY').startOf('day').valueOf() === moment().startOf('day').valueOf()
                        return <th key={`head-up-${index}`} className={`p-3 ${active ? 'th-active':''}`} style={{minWidth:125, textTransform: 'capitalize'}}>{dayName}</th>
                    })}
                </tr>
                <tr>
                    {dates&&dates?.map((dateItem:any,index:number)=>{
                        const active = moment(dateItem, 'DD/MM/YYYY').startOf('day').valueOf() === moment().startOf('day').valueOf()
                        return <th key={`head-down-${index}`} className={`p-3 ${active ? 'th-active':''}`} style={{minWidth:125}}>{dateItem}</th>
                    })}
                </tr>
            </thead>
        )
    }

    const RenderBobyData = () => {
        if (shifts?.length === 0) {
            return <RowEmpty style={{backgroundColor: 'unset'}} column={(dates?.length || 0) + 2} title="Chưa có lịch làm việc cho khoảng thời gian này" />;
        }
        return (
            <tbody>
                {shifts?.map((item: any, index: number) => {
                    return(
                        <Fragment  key={`${item?.id}-${index}`}>
                            <tr key={`${item?.id}-${index}`}>
                                <td className='text-left td-title' rowSpan={clinics?.length + 1}>
                                    <b>{item?.name}</b><br/>
                                    <p>{item?.time_from} - {item?.time_to}</p>
                                </td>
                            </tr>
                            {clinics?.map((itemClinic:any, numberClinic:number)=>{
                                return (
                                    <tr key={`${item?.id}-${index}-${numberClinic}`}>
                                        <td className='text-left td-title'>{itemClinic?.name}</td>
                                        {dates&&dates?.map((dateItem:any,indexDate:number)=>{
                                            const active = moment(dateItem, 'DD/MM/YYYY').startOf('day').valueOf() === moment().startOf('day').valueOf()
                                            const sheetItem = sheetLockUp && sheetLockUp[item?.id] && sheetLockUp[item?.id][itemClinic?.id] && sheetLockUp[item?.id][itemClinic?.id][moment(dateItem, 'DD/MM/YYYY').startOf('day').valueOf()] || {}
                                            const isPast = moment().valueOf() > moment(`${moment(dateItem, 'DD/MM/YYYY').format('DD/MM/YYYY')} ${item?.time_to}`, 'DD/MM/YYYY HH:mm').valueOf()
                                            
                                            if(active){
                                                console.log("sheetItem", sheetItem?.user_id?.name, sheetLockUp)
                                            }
                                            return <td key={`${item?.id}-${index}-${numberClinic}-${indexDate}`} className='p-0' style={{minWidth:125}}>
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',

                                                }}>
                                                    <Select
                                                        className={`react-select react-select-noline shift-sheet-item ${
                                                            (active && sheetItem?.status === 1) ? 'status-active' :
                                                            (active && sheetItem?.status === 2)? 'status-pending' :
                                                            (active && sheetItem?.status === 0) ? 'status-disabled' : ''}`}
                                                        classNamePrefix="react-select"
                                                        placeholder=""
                                                        options={doctor}
                                                        onChange={(value: any) => {
                                                            handleChangeDoctor({
                                                                shift_id: data?.id,
                                                                shift_line_id: item?.id,
                                                                clinic_id: itemClinic?.id,
                                                                branch_id: user?.branch_id?.id,
                                                                day: moment(dateItem, 'DD/MM/YYYY').startOf('day').valueOf(),
                                                                user_id: value.value || null,
                                                                status: 1,
                                                            },sheetItem)
                                                        }}
                                                        isDisabled={isPast || !checkRole(props?.user?.roles, ['addSheet', 'editSheet'], props?.user?.role)}
                                                        value={doctor?.filter((option: any) => sheetItem?.user_id?.id === option.value)}
                                                        components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}
                                                        menuPlacement={(clinics?.length === numberClinic + 1 || clinics?.length === numberClinic) ? "top": "bottom"}
                                                        styles={{
                                                            ...customStyles,
                                                            menu: ({ width, ...css }) => ({
                                                                ...css,
                                                                minWidth: 280,
                                                                maxHeight: 140
                                                            }),
                                                        }}
                                                    ></Select>
                                                    {(active && sheetItem?.status === 2) && 
                                                        <span className='shift-sheet-item-note mt-0 pr-2 pl-2 pb-2'>Tạm nghỉ {moment(sheetItem?.break_time_from).format('HH:mm')} - {moment(sheetItem?.break_time_to).format('HH:mm')}</span>
                                                    }
                                                </div>
                                            </td>
                                        })}
                                    </tr>
                                )
                            })}
                            <tr key={`break-${item?.id}-${index}`}>
                                <td colSpan={clinic?.length + 2} className='calendar-break-td'>
                                    <div className='calendar-break'></div>
                                </td>
                            </tr>
                        </Fragment>
                    )
                })}
            </tbody>
        )
    }

    return (
        <PageContent>
            <PageBody>
                <DataFilter
                    user={user}
                    filter={filter}
                    clinic={clinic}
                    setFilter={(filter: any) => setFilter(filter)}
                    handleActionModal={(data: any) => handleActionModal(data)}
                />
                <RenderStatus/>
                <div className='calendar-table shift-table' style={{overflow: 'unset'}}>
                    <Table className="mb-0 table-bordered" >
                        <RenderHeadData />
                        <RenderBobyData />
                    </Table>
                </div>
            </PageBody>
            {loading && <Loader />}
        </PageContent>
    )
}

const ContentShiftPage = (props:any) => {
    const {type, user, onlyView, action, handleActionModal, from, filter, setFilter} = props
    const [id, setId] = useState<any>()
    const [dataList, setDataList] = useState<any>([])
    const [data, setData] = useState<any>({})
    const [detail, setDetail] = useState<any>([
        {
            "sort": 1,
            "name": "",
            "time_from": "",
            "time_to": ""
        }
    ])
    const [loading, setLoading] = useState(false)
    const router = useHistory()
    useEffect(() => {
        loadDataList()
        if(id && id !== 'add') loadData(id)
    }, [user?.branch_id?.id, id]);

    useEffect(() => {
        if(dataList?.length === 0 && !data?.id){
            setFilter({
                ...filter,
                action:'add'
            })
            setData({
                ...data,
                day_from: moment().startOf('isoWeek').valueOf()
            })
        }else if(dataList?.length > 0 && !data?.id && id !== 'add'){
            //cho nó xem cái hiện tại
            const dataCurent = dataList?.filter((item:any)=>{
                const status = getStatus(item)
                return status?.value === 1
            })
            if(dataCurent && dataCurent[0]){
                setFilter({
                    ...filter,
                    action:'view'
                })
                setId(dataCurent[0]?.id)
            }
        }
    }, [dataList]);

    const loadDataList = async () => {
        const url = `${baseUrl}/shift`;
        setLoading(true)
        let response: any = await APIClient.GET(url,{
            branch_id: user?.branch_id?.id
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            setDataList(resData?.data)
            // setDataList([])
        }
    }

    const loadData = async (id:number) => {
        const url = `${baseUrl}/shift/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            setData({
                ...resData,
                day_from: moment(resData?.day_from).valueOf(),
                day_to: moment(resData?.day_to).valueOf(),
            })
            setDetail(resData?.detail)
            if(resData?.detail?.length === 0){
                setDetail([
                    {
                        "sort": 1,
                        "name": "",
                        "time_from": "",
                        "time_to": ""
                    }
                ])
            }
        }
    }
      
    const handleAddLine = () => {
        const newLine = {
            sort: "",
            name:  "",
            time_from: "",
            time_to: "",
        };
    
        setDetail([...detail, newLine]);
    };
    
    const handleUpdateLine = (dataLine: any, index: number) => {
        let newLine = cloneDeep(detail);
        newLine[index] = dataLine;
        setDetail(newLine);
    };
    
    const handleRemoveLine = (index: number) => {
        let newLine = cloneDeep(detail);
        newLine.splice(index, 1);
        if(newLine?.length === 0) {
          newLine.push({
            sort: "",
            name:  "",
            time_from: "",
            time_to: "",
          })
        }
        setDetail(newLine);
    };

    const validationFrom = () => {
        if (!(data.day_from) || !(data.day_to)) {
            toast.warning('Thời gian áp dụng không được để trống!');
            return false
        }
        if(
            // moment(data.day_to).diff(moment(data.day_from), 'days') > 7 || 
            moment(data.day_to).diff(moment(data.day_from), 'days') < 0 
        ){
            toast.warning('Thời gian áp dụng phải bắt đầu từ Thứ 2 và kết thúc vào Chủ Nhật');
            return false
        }
        const validateDetail= detail?.map((e:any, index:number) => {
            //check emptry
            if(
                (!e?.name || !e?.time_from || !e?.time_to)
            ) {
                toast.warning(`Nhập đầy đủ thông tin ca làm việc`);
                return false
            }
            //check trùng ca
            const time_from = moment(e?.time_from, 'HH:mm').valueOf()
            const time_to = moment(e?.time_to, 'HH:mm').valueOf()
            const lineDuplicate = detail?.filter((iFilter:any, indexFilter:number)=>{
                const i_time_from = moment(iFilter?.time_from, 'HH:mm').valueOf()
                const i_time_to = moment(iFilter?.time_to, 'HH:mm').valueOf()
                return (
                    indexFilter !== index && time_from >= i_time_from && time_from < i_time_to
                )||(
                    indexFilter !== index &&  time_to > i_time_from && time_to <= i_time_to
                )
            })
            if(
                lineDuplicate?.length > 0
            ) {
                toast.warning(`Ca làm việc không được trùng nhau`);
                return false
            }
        })
        const checkDetail = validateDetail?.findIndex((e:any) => e === false)
        if(checkDetail > -1) {
            return false
        }
        return true
    }
    
    const handleSubmit = async() => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/shift`;
        const params = {
            "name": data?.name,
            "day_from": data?.day_from,
            "day_to": data?.day_to,
            "branch_id": user?.branch_id?.id,
            "status": 0,
            "detail": detail?.reduce((prev:any, item:any, index:number) => {
                prev = [...prev,{
                    "id": item?.id || undefined,
                    "name": item?.name,
                    "morning_to": item?.morning_to,
                    "time_from": item?.time_from,
                    "time_to": item?.time_to,
                    "sort": index + 1,
                }]
                return prev
            },[]),
        }
        let response: any = await APIClient.POST(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Lưu ca làm việc của phòng khám thành công')
            loadDataList()
            setId(response.response?.id)
            setFilter({
                ...filter,
                action: 'view'
            })
        }
    }

    const handleEdit = async(checkConflicTime:boolean = false) => {
        if (!validationFrom()) return;
        if(checkConflicTime){
            const lastShift = dataList && dataList?.length > 0 && dataList[0]
            console.log("checkConflicTime", lastShift, data)
            if(lastShift && lastShift?.id !== data?.id){
                if(
                    moment(data?.day_to).valueOf() >= moment(lastShift?.day_to).valueOf()
                ){
                    //xoas casi taoj truowsc
                    return handleActionModal({
                        type: 'deleteFutureConfirm',
                        onSubmit: () => {
                            handleEdit()
                        }
                    })
                }else if(
                    moment(data?.day_to).valueOf() > moment(lastShift?.day_from).valueOf()
                    && moment(data?.day_to).valueOf() < moment(lastShift?.day_to).valueOf()
                ){
                    //ddieefu chinhr ngafy taoj truowsc
                    return handleActionModal({
                        type: 'editFutureConfirm',
                        onSubmit: () => {
                            handleEdit()
                        }
                    })
                }
            }
        }
        
        setLoading(true)
        const url = `${baseUrl}/shift/${id}`;
        const params = {
            "name": data?.name,
            "day_from": data?.day_from,
            "day_to": data?.day_to,
            "branch_id": user?.branch_id?.id,
            "status": 0,
            "detail": detail?.reduce((prev:any, item:any, index:number) => {
                prev = [...prev,{
                    "id": item?.id || undefined,
                    "name": item?.name,
                    "morning_to": item?.morning_to,
                    "time_from": item?.time_from,
                    "time_to": item?.time_to,
                    "sort": index + 1,
                }]
                return prev
            },[]),
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Lưu cài ca làm việc của phòng khám thành công')
            loadDataList()
            setId(response.response?.id)
            setFilter({
                ...filter,
                action: 'view'
            })
        }
    }

    const handleDelete = async() => {
        setLoading(true)
        const url = `${baseUrl}/shift/${id}`;
        let response: any = await APIClient.DELETE(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xóa ca làm việc của phòng khám thành công')
            setData({
            })
            loadDataList()
        }
    }

    const handleReset = ()=>{
        setId('add');
        setDetail([
            {
                "sort": 1,
                "name": "",
                "time_from": "",
                "time_to": ""
            }
        ])
        setData({})
        setFilter({
            ...filter,
            action: 'add'
        })
    }

    const status = getStatus(data)
    const last_day_to = Math.max(...dataList.map((o:any) => moment(o.day_to).valueOf()))
    const last_day_from = Math.max(...dataList.map((o:any) => moment(o.day_from).valueOf()))
    const statusLast = getStatus({
        day_from: last_day_from,
        day_to: last_day_to,
    })

    
    if(!checkRole(props?.user?.roles, ['viewShift'], props?.user?.role)) return null

    console.log("statusLast", statusLast)

    return (
        <PageContent className={filter?.action === 'view' ? 'only-view' : ''}>
            <Row>
                <Col md={7}>
                    <PageBody>
                        <div className="nutri-title mb-3">Thông tin ca</div>
                        <Row>
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Thời gian áp dụng từ</Label>
                                    <Flatpickr
                                        value={[data?.day_from && new Date(moment(data?.day_from).startOf('days').valueOf())]}
                                        onChange={(date: any) => {
                                            setData({
                                                ...data,
                                                day_from: date[0] ? moment(date[0]).valueOf() : undefined,
                                            })
                                        }}
                                        options={{
                                            locale: Vietnamese,
                                            allowInput:true,
                                            dateFormat: "d/m/Y",
                                            "disable": [
                                                function(date) {
                                                    // return true to disable
                                                    return (date.getDay() !== 1);

                                                }
                                            ],
                                            minDate: filter?.action === 'add' ? moment().startOf('isoWeek').startOf('day').valueOf() : undefined
                                        }}
                                        disabled={
                                            (id !== 'add' && status?.value === 3) 
                                            || (id === 'add' && statusLast?.value === 1)
                                            || (id !== 'add' && status?.value === 2) 
                                            || (id !== 'add' && status?.value === 1) 
                                        }
                                        placeholder="dd/mm/yyyy"
                                    />
                                    <InputGroupAddon addonType="append" className='d-flex align-items-center' style={{right: 20}}>
                                            <img src={IconCalendarBlack} alt="icon" />
                                    </InputGroupAddon>
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Thời gian áp dụng đến</Label>
                                    <Flatpickr
                                        value={[data?.day_to && new Date(moment(data?.day_to).startOf('days').valueOf())]}
                                        onChange={(date: any) => {
                                                setData({
                                                    ...data,
                                                    day_to: date[0] ? moment(date[0]).valueOf() : undefined,
                                                })
                                        }}
                                        options={{
                                            locale: Vietnamese,
                                            allowInput:true,
                                            dateFormat: "d/m/Y",
                                            "disable": [
                                                function(date) {
                                                    // return true to disable
                                                    return (date.getDay() !== 0);

                                                }
                                            ],
                                            minDate: filter?.action === 'add' ? moment().endOf('isoWeek').startOf('day').valueOf() : undefined
                                        }}
                                        disabled={id !== 'add' && status?.value === 3}
                                        placeholder="dd/mm/yyyy"
                                    />
                                    <InputGroupAddon addonType="append" className='d-flex align-items-center' style={{right: 20}}>
                                            <img src={IconCalendarBlack} alt="icon" />
                                    </InputGroupAddon>
                                </FormGroup>
                            </Col>
                            {statusLast?.value !== 2 && dataList?.length > 0 &&
                            <Col md={4} xs={12} style={{textAlign: 'right'}}>
                                <Button color="success" className='ml-2' onClick={()=>{
                                    //lấy ngày kết thúc lớn nhất
                                    const day_from = dataList?.length === 0 ? moment().startOf('isoWeek').valueOf(): moment(last_day_to).add(1, 'day').valueOf()
                                    const day_to = dataList?.length === 0 ? moment().endOf('isoWeek').valueOf() : moment(last_day_to).add(7, 'day').valueOf()
                                    
                                    setDetail([
                                        {
                                            "sort": 1,
                                            "name": "",
                                            "time_from": "",
                                            "time_to": ""
                                        }
                                    ])
                                    setData({
                                        day_from,
                                        day_to
                                    })
                                    setFilter({
                                        ...filter,
                                        action: 'add'
                                    })
                                    setId('add');
                                }}>{dataList?.length === 0 ? "Tạo mới":"Tạo trước"}</Button>
                            </Col>}
                        </Row>
                        <div className="table-responsive" style={{ overflow: "unset" }}>
                            <Table className="mb-0 table-custom no-bg">
                            <thead>
                                <tr>
                                <th style={{ minWidth: 30 }}>STT</th>
                                <th style={{ minWidth: 200 }}>Tên ca</th>
                                <th style={{ minWidth: 120 }}>Thời gian bắt đầu</th>
                                <th style={{ minWidth: 120 }}>Thời gian kết thúc</th>
                                {filter?.action !== 'view' &&<th style={{ minWidth: 120 }}>Thao tác</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {detail && detail?.map((item: any, index: number) => {
                                    return (
                                    <>
                                        <LineItem
                                            id={id}
                                            keyIndex={index}
                                            data={item}
                                            filter={filter}
                                            total={detail?.length}
                                            onChangeData={(dataRela: any) =>
                                                handleUpdateLine(dataRela, index)
                                            }
                                            handleRemoveData={() => handleRemoveLine(index)}
                                            handleAddData={() => handleAddLine()}
                                            status={status}
                                        />
                                    </>
                                    )
                                })}
                            </tbody>
                            </Table>
                        </div>
                    </PageBody>
                </Col>
                <Col md={5}>
                    <PageBody>
                        <div className="nutri-title mb-3">Danh sách ca làm việc</div>
                        <ShiftDataTableList
                            data={dataList} 
                            filter={filter}
                            setFilter={setFilter}
                            loading={loading}
                            id={id}
                            setId={setId}
                            handleActionModal={(data: any) => handleActionModal(data)}
                        />
                    </PageBody>
                </Col>
            </Row>
            <div className="bottom-action">
                <Button color="success" className='success-bland ml-2' onClick={() => {
                    if(filter?.action === 'edit') {
                        return handleActionModal({
                            type: 'cancelConfirm',
                            onSubmit: () => {
                                setFilter({
                                    ...filter,
                                    action: 'view'
                                })
                                loadDataList()
                                loadData(id)
                            }
                        })
                    }else{
                        handleReset()
                    }
                    
                }}>Đóng</Button>
                {checkRole(props?.user?.roles, ['editShift'], props?.user?.role) && filter?.action === 'view' && status?.value !== 3 &&<Button color="success" className='success-bland ml-2' onClick={() => setFilter({
                    ...filter,
                    action: 'edit'
                })}>Chỉnh sửa</Button>}
                {checkRole(props?.user?.roles, ['deleteShift'], props?.user?.role) && filter?.action === 'view' && status?.value === 2 &&<Button color="danger" className='danger-bland ml-2' onClick={() => {
                    handleActionModal({
                        type:'deleteConfirm',
                        onSubmit: () => {
                            handleDelete()
                        }
                    })
                }}>Xóa</Button>}
                {checkRole(props?.user?.roles, ['editShift'], props?.user?.role) && filter?.action === 'edit' && status?.value !== 3 && <Button color="success" className='ml-2' onClick={()=>handleEdit(true)}>Lưu</Button>}
                {checkRole(props?.user?.roles, ['addShift'], props?.user?.role) && filter?.action === 'add' && <Button color="success" className='ml-2' onClick={handleSubmit}>Tạo</Button>}
            </div>
            {loading && <Loader />}
        </PageContent>
    )
}

const LineItem = (props: any) => {
    const {
        id,
        filter,
        keyIndex,
        data,
        onChangeData,
        handleAddData,
        handleRemoveData,
        total,
        status
    } = props;
    
    const handleChange = (e: any) => {
      const { name, value } = e?.target;
        onChangeData({
          ...data,
          [name]: value,
        });
    };
    
    return (
      <tr key={`line_${keyIndex}`}>
        <td>{keyIndex + 1}</td>
        <td>
            <Input disabled={data?.id && status?.value !== 2} type="text" value={data?.name || ''} name="name" onChange={handleChange} placeholder={"Tên ca"} />
        </td>
        <td>
            <Flatpickr
                value={[
                    new Date(moment(data?.time_from,'HH:mm').valueOf())
                ]}
                onChange={(date: any) => {
                    onChangeData({
                        ...data,
                        time_from: date[0] ? moment(date[0]).format('HH:mm') : undefined,
                    })
                }}
                disabled={data?.id && status?.value !== 2}
                className='form-control'
                options={{
                    locale: Vietnamese,
                    allowInput:true,
                    dateFormat: "H:i",
                    mode: "time",
                    time_24hr: true,
                }}
                placeholder="HH:mm"
            />
        </td>
        <td>
            <Flatpickr
                value={[
                    new Date(moment(data?.time_to,'HH:mm').valueOf())
                ]}
                onChange={(date: any) => {
                    onChangeData({
                        ...data,
                        time_to: date[0] ? moment(date[0]).format('HH:mm') : undefined,
                    })
                }}
                disabled={data?.id && status?.value !== 2}
                className='form-control'
                options={{
                    locale: Vietnamese,
                    allowInput:true,
                    dateFormat: "H:i",
                    mode: "time",
                    time_24hr: true
                }}
                placeholder="HH:mm"
            />
        </td>
        {filter?.action !== 'view' &&
        <td>

            <div className="table-action" style={{ justifyContent: 'flex-end'}}>
                {filter?.action === 'add' &&
                    <>
                        <div
                            className="button-nutri"
                            onClick={() =>handleRemoveData(keyIndex)}
                        >
                            <i className="uil-trash-alt"></i>
                        </div>
                        {total == keyIndex + 1 && (
                        <div className="button-nutri action-bg ml-2" onClick={handleAddData}>
                            <i className="uil-plus"></i>
                        </div>
                        )}
                    </>
                }
                {filter?.action === 'edit' && status?.value === 2 &&
                    <>
                        <div
                            className="button-nutri"
                            onClick={() =>handleRemoveData(keyIndex)}
                        >
                            <i className="uil-trash-alt"></i>
                        </div>
                        {total == keyIndex + 1 && (
                        <div className="button-nutri action-bg ml-2" onClick={handleAddData}>
                            <i className="uil-plus"></i>
                        </div>
                        )}
                    </>
                }
            </div>
        </td>}
      </tr>
    );
};

const getStatus = (item:any)=>{
    const {day_from, day_to} = item;
    if(moment(day_from).valueOf() > moment().valueOf()){
        return {
            text: "Chưa áp dụng",
            value: 2,
        }
    }else if(moment(day_to).valueOf() < moment().valueOf()){
        return {
            text: "Đã kết thúc",
            value: 3,
        }
    }else{
        return {
            text: "Đang áp dụng",
            value: 1,
        }
    }
}

const ShiftDataTableList = (props: any) => {
    const { data, loading, setId, id, filter, setFilter} = props
    
    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th>Thời gian áp dụng</th>
                    <th>Trạng thái áp dụng</th>
                </tr>
            </thead>
        )
    }

    const RenderBobyData = () => {
        const router = useHistory()
        if (loading) {
            return <RowLoading column={3} row={data.length} />
        }
        if (data.length === 0) {
            return <RowEmpty column={3} title="Chưa có ca làm việc nào!" />;
        }
        return (
            <tbody>
                {
                    data?.map((item:any, index:number) => {
                        const status = getStatus(item)
                        return(
                            <tr key={`food_${index}`} style={{ background: id === item?.id ? '#EDF7E6': ''}}>
                                <td onClick={() => gotoDetail(item)}>{moment(item?.day_from)?.format('DD/MM/YYYY')} - {moment(item?.day_to)?.format('DD/MM/YYYY')}</td>
                                <td onClick={() => gotoDetail(item)}>{status?.text}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        )
    }

    const gotoDetail = (item:any) => {
        setFilter({
            ...filter,
            action: 'view'
        })
        setId(item?.id)
    }

    const columns = [
        {
          dataField: "day_from",
          text: "Thời gian áp dụng",
          formatter: (value:any, item: any) => {
            return (
              <span>
                {moment(item?.day_from)?.format('DD/MM/YYYY')} - {moment(item?.day_to)?.format('DD/MM/YYYY')}
              </span>
            );
          },
        },
        {
          dataField: "day_from",
          text: "Trạng thái áp dụng",
          formatter: (value:any, item: any) => {
            return (
              <span>
                {getStatus(item)?.text}
              </span>
            );
          },
        },
    ];

    const rowClasses = (row:any, rowIndex:number) => {
        return `shift-table-item ${id === row?.id ? "active":""}`;
      };

    const customTotal = (from:any, to:any, size:any) => (
        <span className="react-bootstrap-table-pagination-total">
          Showing { from } to { to } of { size } Results
        </span>
      );

    const options = {
        paginationSize: 4,
        pageStartIndex: 1,
        // alwaysShowAllBtns: true, // Always show next and previous button
        // withFirstAndLast: false, // Hide the going to First and Last page button
        // hideSizePerPage: true, // Hide the sizePerPage dropdown always
        // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
        firstPageText: 'Trang đầu',
        prePageText: 'Trước',
        nextPageText: 'Sau',
        lastPageText: 'Cuối',
        nextPageTitle: 'Trang đầu',
        prePageTitle: 'Trang trước',
        firstPageTitle: 'Trang sau',
        lastPageTitle: 'Trang cuối',
        showTotal: false,
        paginationTotalRenderer: customTotal,
        disablePageTitle: true,
        sizePerPageList: [
            {
                text: '10 bản ghi', value: 10
            },
            {
                text: '15 bản ghi', value: 15
            },
            {
                text: '20 bản ghi', value: 20
            },
            {
                text: '50 bản ghi', value: 50
            },
            {
                text: 'Tất cả', value: data.length
            }
        ]
      };

    return (
        <PageContentTable>
            {/* <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table> */}
            <div className="table-responsive" style={{ overflow: "unset" }}>
                <table className="mb-0 table-custom no-bg table table-input">
                    <BootstrapTable
                        keyField="id"
                        data={data || []}
                        columns={columns}
                        rowClasses={ rowClasses }
                        rowEvents={ {
                            onClick: (e, row, rowIndex) => {
                                console.log(row);
                                gotoDetail(row)
                            },
                            onMouseEnter: (e, row, rowIndex) => {
                                console.log(`enter on row with index: ${row}`);
                            }
                            } }
                        // {...paginationTableProps}
                        pagination={ paginationFactory(options) }
                        
                    />
                </table>
            </div>
        </PageContentTable>
    );
};

const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState<any>(false);
    const [data, setData] = useState<any>({});
    const { closeModal, action, loadData } = props
    const router=useHistory()

    const handleConfirm = async() => {
        action?.onSubmit()
        closeModal()
    }

    return (
        <CardBody className='p-0' style={{width: 400}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    Thông báo
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body pt-2 pb-2">
                <Col md={12}>
                    <FormGroup row className="label-only">
                        {(action?.type === 'active' || action?.type === 'cancelConfirm') &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc muốn huỷ tất cả các thay đổi?</p>
                        } 
                        {(action?.type === 'deleteConfirm') &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc muốn xoá cấu hình ca làm việc này?</p>
                        } 
                        {(action?.type === 'deleteFutureConfirm') &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Thời gian tạo ca trùng với thời gian ca tạo trước, sẽ xóa ca tạo trước nếu tiếp tục?</p>
                        }
                        {(action?.type === 'editFutureConfirm') &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Thời gian tạo ca trùng với thời gian ca tạo trước, sẽ cập nhật lại thời gian bắt đầu của ca tạo trước nếu tiếp tục?</p>
                        }
                        {(action?.type === 'changeDoctorConfirm') &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>{action?.title}</p>
                        }
                    </FormGroup>
                </Col>
            </div>
            <div className="modal-footer">
                <Button
                    onClick={closeModal}
                    className="ml-2 success-bland" color="success" type="button"
                > Hủy bỏ</Button>
                <Button
                    onClick={()=>{
                        (
                            action?.type === 'cancelConfirm' 
                            || action?.type === 'deleteFutureConfirm'
                            || action?.type === 'changeDoctorConfirm'
                            || action?.type === 'cancelConfirm'
                            || action?.type === 'deleteConfirm'
                        ) && handleConfirm()
                    }}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>
            {loading && <Loader />}
        </CardBody>

    )
}

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`

const PageContentTable = styled.div`
    .react-bootstrap-table-pagination{
        padding: 0px 15px;
    }
`

const customStyles = {
    menuList: (base:any) => ({
        ...base,
        maxHeight: 140,
        overflowY: "auto"
    }),
};

export default connect(mapState)(Shift)